import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/home/index.vue'
import change from '../views/home/changedata.vue'
import machine from '../views/home/machine.vue'
import admin from '../views/home/admin.vue'
import user from '../views/home/user.vue'
import group from '../views/home/group.vue'
import record from '../views/home/record.vue'
import scheme from '../views/home/scheme.vue'
import seturl from '../views/home/seturl.vue'
import login2 from '../views/home/login2.vue'
import login3 from '../views/home/login3.vue'

Vue.use(VueRouter)

const routes = [ 
  {
    path: '/home',
    name: 'home',
    component: index
  },
  {
    path: '/change',
    name: 'change',
    component: change
  },
  {
    path: '/record',
    name: 'record',
    component: record
  },  
  {
    path: '/machine',
    name: 'machine',
    component: machine
  },
  {
    path: '/user',
    name: 'user',
    component: user
  },  
  {
    path: '/group',
    name: 'group',
    component: group
  },    
  {
    path: '/admin',
    name: 'admin',
    component: admin
  },
  {
    path: '/scheme',
    name: 'scheme',
    component: scheme
  },{
    path: '/seturl',
    name: 'seturl',
    component: seturl
  },{
    path: '/login3',
    name: 'login3',
    component: login3
  },{
    path: '/login2',
    name: 'login2',
    component: login2
  }
]

const router = new VueRouter({
  routes
})

export default router
